module.exports = __webpack_public_path__ + "static/img/grac-oidd-competition-pt02.81a85bf.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing-detail/grac-oidd-competition-pt02.jpg
// module id = ncqt
// module chunks = 0